import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Top Section */}
        <div className="footer-top">
          <div className="footer-brand">
            <img src="/assets/logo-light.png" alt="Özel Uitzendbureau" className="footer-logo" />
            <p className="footer-tagline">
              Uw vertrouwde partner in personeel. Wij leveren vakmensen aan de maritieme, bouw, metaal en industriële sector.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-links-col">
              <h4>Snel naar</h4>
              <ul>
                <li><a href="#over-ons">Over Ons</a></li>
                <li><a href="#hoe-het-werkt">Hoe Het Werkt</a></li>
                <li><a href="#vacatures">Vacatures</a></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="footer-links-col">
              <h4>Sectoren</h4>
              <ul>
                <li>Maritiem</li>
                <li>Bouw</li>
                <li>Metaal</li>
                <li>Industrie</li>
                <li>Brandwacht</li>
              </ul>
            </div>

            <div className="footer-links-col">
              <h4>Contact</h4>
              <ul>
                <li>Schuttevaerweg 81</li>
                <li>3044BA Rotterdam</li>
                <li><a href="tel:+31104159100">010 415 9100</a></li>
                <li><a href="mailto:info@ozel.eu">info@ozel.eu</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom Section */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Özel Uitzendbureau B.V. - Alle rechten voorbehouden
          </p>
          <div className="footer-legal">
            <Link to="/contact">Contact</Link>
            <span className="footer-dot">•</span>
            <span>KVK: 24397850</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
